<template>
  <main class="mdl-layout__content">
    <div class="page-content">
      <h1 class="mdl-typography--headline">Avdelinger</h1>
      <ul class="demo-list-item mdl-list">
        <li v-for="department in departments" class="mdl-list__item">
          <router-link :to="{name: 'department', params: {id: department.id}}"><span class="mdl-list__item-primary-content" v-text="department.id + ' ' + department.name + ' ' + department.email"></span></router-link>
        </li>
      </ul>
      <router-link v-if="$root.isEuropcarAdmin() || $root.isAdministrator()" id="new-assessment" class="mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored" :to="{ name: 'new-department'}">
        <i class="material-icons">add</i>
      </router-link>
    </div>
  </main>
</template>

<script>
  //import mdlFix from '../mixins/mdlFix.js'
  //import utils from '../mixins/utils.js'

  export default {
    data () {
      return {
          departments: []
      }
    },
    methods:{
        getDepartments(){
            var self = this
            self.$root.ui.loading.push('editor');
            return self.$store.dispatch('getDepartments').then(function(departments){
              self.$root.ui.stopLoading('editor');
              if(departments)
                  self.departments = departments
            })
        },
    },
    created(){
        this.getDepartments()
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
          if( !(vm.$root.isEuropcarAdmin() || vm.$root.isAdministrator()) )
            vm.$router.push({name: 'reports'})
        })
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Editor.vue?e1e64076